export default __webpack_public_path__ + "static/media/closegrey.e0a1b321.svg";